import {
    INVALID_LOGIN_USER,
    LOGIN_USER,
    LOGOUT,
    REFRESH_TOKEN_TIME,
    UPDATE_SECURITY_QUESTION_TAG,
    RESET
} from "../types/authenticationType";

const initialState = {
    user: {},
    accessToken: null,
    refreshToken: null,
    loginError: null,
    twoFaErrorObj: {},
    isAuthenticated: false,
    expiresIn: null,
    expiresDatetime: null
};

const authenticationReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case LOGIN_USER:
            return {
                ...state,
                isAuthenticated: true,
                user: payload.decoded,
                accessToken: payload.access_token,
                refreshToken: payload.refresh_token,
                expiresIn: payload.expires_in,
                expiresDatetime: payload.expires_datetime
            };
        case INVALID_LOGIN_USER:
            return {
                ...state,
                loginError: payload.msg,
                twoFaErrorObj: payload.data
            };
        case LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                accessToken: null,
                refreshToken: null
            };
        case REFRESH_TOKEN_TIME:
            return {
                ...state,
                expiresIn: payload.expires_in
            };
        case UPDATE_SECURITY_QUESTION_TAG:
            return {
                ...state,
                user: payload.user
            };
        case RESET:
            return {
                ...state,
                twoFaErrorObj: {},
                loginError: null
            };
        default:
            return state;
    }
};

export default authenticationReducer;
